<template>
  <Container>
    <v-flex justify-start>
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Match Card Manager</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn icon color="green" v-on:click="toggleSelectCategory">
            <v-icon>add</v-icon>
          </v-btn>
          <v-text-field
            solo
            placeholder="Search"
            append-icon="search"
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-tile
              v-for="matchcard in matchcardStore.matchcard"
              :key="matchcard.category_id"
              v-on:click="() => onClickEdit(matchcard.category_id)"
            >
              <v-list-tile-avatar>
                <v-icon>view_module</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ matchcard.category }} ({{
                    matchcard.decks.length
                  }})</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >Updated at {{ matchcard.updated_at }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <Category
      :v-if="isSelectCategory"
      :isOpen="isSelectCategory"
      :close="toggleSelectCategory"
      :onSelect="onClickSelectCategory"
      :value="categoryId"
      title="Select Category"
    >
    </Category>
  </Container>
</template>
<script>
import Container from '../../components/Container';
import Category from '../../components/Category';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'MatchCardList',
  components: {
    Container,
    Category,
  },
  data: function () {
    return {
      isSelectCategory: false,
      categoryId: '',
    };
  },
  methods: {
    ...mapActions('matchcard', [
      'fetchMatchCard',
      'selectMatchCard',
      'selectCategory',
    ]),
    onClickEdit(id) {
      this.selectMatchCard(id);
      this.selectCategory();
      this.$router.push({
        path: '/matchcard/detail',
        query: {
          id,
        },
      });
    },
    toggleSelectCategory() {
      this.isSelectCategory = !this.isSelectCategory;
    },
    onClickSelectCategory(id) {
      this.isSelectCategory = false;
      this.selectCategory(id);
      this.selectMatchCard();
      this.$router.push({
        path: '/matchcard/detail',
        query: {
          id,
        },
      });
    },
  },
  mounted() {
    this.fetchMatchCard({
      page: 1,
      limit: 0,
    });
  },
  computed: {
    ...mapState({
      matchcardStore: state => state.matchcard,
    }),
  },
};
</script>
